import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PropTypes from "prop-types";
import { ParticipantUpdate } from "./ParticipantUpdate";
import DACIPagination from "components/DACIPagination";
import { Pagination, Stack, Box, Grid, useTheme, useMediaQuery } from "@mui/material";
import usePermission from "hooks/usePermission";
import { fetchWrapper } from "fetchWrapper";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useMaterialUIController } from "context";
import colors from "assets/theme/base/colors";

export default function ParticipantList({
  handleParticipantCreate,
  handleParticipantList = [], // Asegúrate de tener un valor predeterminado
  handleopenNewUpload,
  entriesStart,
  entriesEnd,
  totalData,
  totalPages,
  currentPage,
  handlePageChange,
  callHandleClickSubmit,
  handleAlert = () => { },
  requestParticipantList = () => { },
  gendersList = [],
  specialProtectionGroupsList = [],
}) {
  // Hook para detectar breakpoints responsivos
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // < 960px
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // < 600px

  // Verificar permisos
  const canCreate = usePermission("Crear", "Participantes");
  const canEdit = usePermission("Editar", "Participantes");
  const canDelete = usePermission("Eliminar", "Participantes");
  const canListEvidence = usePermission("Listar", "Evidencias");

  const [modalOpen, setModalOpen] = useState(false);
  const [currentParticipant, setCurrentParticipant] = useState(null);
  const [participants, setParticipants] = useState(handleParticipantList);

  let { white, text } = colors;

  const iconColor = text.main; // #7b809a - mismo color que el texto de las tablas
  white = white.main;

  // Obtener el estado del tema (modo oscuro/claro)
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  useEffect(() => {
    setParticipants(handleParticipantList);
  }, [handleParticipantList]);

  const handleOpenModal = (participant) => {
    setCurrentParticipant(participant);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setCurrentParticipant(null);
  };

  const updateParticipantInBackend = async (updatedParticipant, id) => {
    try {
      if (!id) {
        throw new Error("ID del participante no proporcionado.");
      }

      const response = await fetchWrapper(
        `${process.env.REACT_APP_BACKEND_URL}/participants/update/${id}/`,
        {
          method: "PUT",
          body: JSON.stringify(updatedParticipant),
        }
      );

      // if (response.ok) {
      // const result = await response.json();
      return response;
      // } else {
      //   const errorText = await response.text();
      //   throw new Error(`Error del servidor al realizar la solicitud: ${errorText}`);
      // }
    } catch (error) {
      const message = "Error del servidor al realizar la solicitud";
      return { success: false, message: error.message || message };
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "Fecha inválida" : date.toISOString().slice(0, 10);
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "N/A";

    // Convertir a string y eliminar cualquier carácter no numérico
    const cleaned = String(phone).replace(/\D/g, '');

    // Si no hay dígitos, retornar N/A
    if (!cleaned) return "N/A";

    // Formatear según la longitud del número
    // Formato para Colombia (código 57): +57 300 300 2345
    if (cleaned.startsWith('57') && cleaned.length >= 12) {
      return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
    }
    // Formato para otros países de 11-13 dígitos: +X XXX XXX XXXX
    else if (cleaned.length >= 11) {
      const countryCodeLength = cleaned.length - 10; // Asumiendo 10 dígitos para el número local
      return `+${cleaned.slice(0, countryCodeLength)} ${cleaned.slice(countryCodeLength, countryCodeLength + 3)} ${cleaned.slice(countryCodeLength + 3, countryCodeLength + 6)} ${cleaned.slice(countryCodeLength + 6)}`;
    }
    // Para números más cortos, formato simple: +XX XXX XXX XXX
    else if (cleaned.length >= 10) {
      return `+${cleaned.slice(0, cleaned.length - 9)} ${cleaned.slice(-9, -6)} ${cleaned.slice(-6, -3)} ${cleaned.slice(-3)}`;
    }
    // Si es muy corto, mostrar con espacios cada 3 dígitos
    else {
      return `+${cleaned.match(/.{1,3}/g)?.join(' ') || cleaned}`;
    }
  };

  const handleUpdateParticipant = async (updatedParticipant) => {
    try {
      if (currentParticipant) {
        const response = await updateParticipantInBackend(
          updatedParticipant,
          currentParticipant.id
        );
        if (response.success) {
          // const updatedParticipants = participants.map((participant) =>
          //   participant.id === result.result.id ? result.result : participant
          // );
          // console.log("se actualizo el participante", updatedParticipants);
          // setParticipants(updatedParticipants); // Actualiza el estado local
          // handleParticipantList(updatedParticipants); // Actualiza el estado en el componente padre
          requestParticipantList(); // Actualiza la lista de participantes
          handleCloseModal(); // Cierra el modal después de una actualización exitosa
        } else {
          handleAlert("fail", response.message); // Muestra el mensaje de error al usuario
          // alert(result.message); // Muestra el mensaje de error al usuario
        } // Muestra el mensaje de error al usuario
        // alert(result.message); // Muestra el mensaje de error al usuario
      } else {
        handleAlert("fail", "Participante no proporcionado."); // Muestra el mensaje de error al usuario
      }
    } catch (error) {
      // console.error("Error al actualizar el participante:", error);
      handleAlert("fail", error.message);
    }
    // .then((result) => {
    //   if (result.success) {
    //     const updatedParticipants = participants.map((participant) =>
    //       participant.id === result.result.id ? result.result : participant
    //     );
    //     console.log("se actualizo el participante", updatedParticipants);
    //     setParticipants(updatedParticipants); // Actualiza el estado local
    //     handleParticipantList(updatedParticipants); // Actualiza el estado en el componente padre
    //     handleCloseModal(); // Cierra el modal después de una actualización exitosa
    //   } else {
    //     handleAlert(result.message); // Muestra el mensaje de error al usuario
    //     // alert(result.message); // Muestra el mensaje de error al usuario
    //   }
    // })
    // .catch((error) => {});
    // }
  };

  const columns = [
    { Header: "Documento", accessor: "document", align: "center" },
    { Header: "Nombre", accessor: "name", align: "center" },
    { Header: "Apellido", accessor: "last_name", align: "center" },
    { Header: "Estado", accessor: "state", align: "center" },
    { Header: "Género", accessor: "gender", align: "center" },
    { Header: "Correo electrónico", accessor: "email", align: "center" },
    { Header: "Teléfono", accessor: "phone", align: "center" },
    { Header: "Tel. Emergencia", accessor: "emergency_phone", align: "center" },
    { Header: "Ubicación Geográfica", accessor: "location", align: "center" },
    { Header: "Programa Académico", accessor: "academic_program", align: "center" },
    { Header: "Período académico", accessor: "semester", align: "center" },
    { Header: "Población Vulnerable", accessor: "vulnerable_populations", align: "center" },
    { Header: "Ultima modificación", accessor: "modified", align: "center" },
    { Header: "Acciones", accessor: "action", width: "12%", align: "center", disableSortBy: true },
  ];

  const rows = participants.map((participant) => {
    // Función para renderizar valores de forma segura
    const safeRender = (value) => {
      if (value === null || value === undefined) return 'N/A';
      if (typeof value === 'object') {
        if (value.subcategory) return value.subcategory.name || 'N/A';
        return value.name || value.code || 'N/A';
      }
      return value;
    };

    return {
      document: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.document)}
        </MDTypography>
      ),
      name: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.name)}
        </MDTypography>
      ),
      last_name: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.last_name)}
        </MDTypography>
      ),
      state: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.state)}
        </MDTypography>
      ),
      gender: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.gender)}
        </MDTypography>
      ),
      email: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {participant.email || "N/A"}
        </MDTypography>
      ),
      phone: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {formatPhoneNumber(participant.phone)}
        </MDTypography>
      ),
      emergency_phone: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {formatPhoneNumber(participant.emergency_phone)}
        </MDTypography>
      ),
      location: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.location)}
        </MDTypography>
      ),
      academic_program: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.academic_program)}
        </MDTypography>
      ),
      semester: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.semester)}
        </MDTypography>
      ),
      vulnerable_populations: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {safeRender(participant.special_protection_group)}
        </MDTypography>
      ),
      modified: (
        <MDTypography variant="body2" style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}>
          {formatDate(participant.modified)}
        </MDTypography>
      ),
      action: (
        <MDBox>
          {canEdit && (
            <a onClick={() => handleOpenModal(participant)} style={{ cursor: "pointer" }}>
              <EditOutlinedIcon
                titleAccess="Editar"
                style={{
                  fontSize: "24px",
                  width: "24px",
                  height: "24px",
                  color: darkMode ? white : iconColor,
                }}
              />
            </a>
          )}
        </MDBox>
      ),
    };
  });

  const navigate = useNavigate();
  const location = useLocation(); // Obtener el estado de la navegación
  const { id: activityId } = useParams(); // Obtener el ID de la actividad desde la URL

  const activityTitle = location.state?.activityTitle || ""; // Recuperar el título de la actividad desde location.state

  const handleNavigateToParticipants = () => {
    navigate(`/Actividades-E/${activityId}`, {
      state: { activityTitle }, // Pasar el título como parte del estado
    });
  };

  return (
    <>
      {/* Contenedor responsivo para todos los botones de acción */}
      <Box sx={{
        mt: isMobile ? 2 : -6,
        mb: 3,
        px: { xs: 1, sm: 2, md: 3 },
        width: '100%'
      }}>
        {/* Botón "Ver evidencias" - Separado en pantallas grandes, integrado en móviles */}
        {canListEvidence && !isMobile && (
          <Box sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mb: 2
          }}>
            <MDButton
              variant="outlined"
              color="info"
              onClick={handleNavigateToParticipants}
              startIcon={<VisibilityIcon />}
              endIcon={<ArrowForwardIcon />}
              size={isSmallScreen ? "small" : "medium"}>
              Ver evidencias de la actividad
            </MDButton>
          </Box>
        )}

        {/* Grid responsivo para botones de acción */}
        <Grid container spacing={1} justifyContent={isMobile ? "center" : "flex-end"} alignItems="center" sx={{ gap: 0 }}>
          {/* Botón de evidencias en móviles */}
          {canListEvidence && isMobile && (
            <Grid item xs={12} sm={12} md={3}>
              <MDButton
                fullWidth
                variant="outlined"
                color="info"
                onClick={handleNavigateToParticipants}
                startIcon={<VisibilityIcon />}
                size="small"
                sx={{ fontSize: '0.75rem' }}>
                Ver evidencias
              </MDButton>
            </Grid>
          )}

          {/* Botones de acción principales */}
          {canCreate && (
            <>
              <Grid item>
                <MDButton
                  onClick={handleParticipantCreate}
                  variant="gradient"
                  color="info"
                  size={isSmallScreen ? "small" : "medium"}
                  sx={{ minWidth: '100px' }}>
                  Crear
                </MDButton>
              </Grid>
              <Grid item>
                <MDButton
                  onClick={handleopenNewUpload}
                  variant="gradient"
                  color="info"
                  size={isSmallScreen ? "small" : "medium"}
                  sx={{ minWidth: '100px' }}>
                  {isSmallScreen ? "Carga" : "Carga masiva"}
                </MDButton>
              </Grid>
            </>
          )}
          <Grid item>
            <MDButton
              onClick={callHandleClickSubmit}
              data-export={true}
              variant="contained"
              color="info"
              size={isSmallScreen ? "small" : "medium"}
              sx={{ minWidth: '100px' }}>
              Exportar
            </MDButton>
          </Grid>
        </Grid>
      </Box>
      <DataTable
        table={{ columns, rows }}
        isSorted={true}
        entriesPerPage={false}
        showTotalEntries={false}
        canSearch={false}
        noEndBorder={false}
      />
      {/* Contenedor responsivo para paginación y estado */}
      {!participants || participants.length === 0 ? (
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4
        }}>
          <MDTypography
            variant="button"
            color="secondary"
            fontWeight="regular"
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              fontFamily: "Roboto, sans-serif"
            }}>
            No hay datos
          </MDTypography>
        </Box>
      ) : (
        <Box sx={{
          px: { xs: 1, sm: 2, md: 3 },
          pb: 2
        }}>
          {/* Información de paginación responsiva */}
          <Box sx={{
            mb: 2,
            textAlign: { xs: 'center', sm: 'left' }
          }}>
            <MDTypography
              variant="button"
              color="secondary"
              fontWeight="regular"
              sx={{
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }}>
              Mostrando {entriesStart} hasta {entriesEnd} de {totalData} resultados en total
            </MDTypography>
          </Box>

          {/* Paginación centrada en móviles */}
          <Box sx={{
            display: 'flex',
            justifyContent: { xs: 'center', sm: 'flex-start' }
          }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              size={isMobile ? "small" : "medium"}
              sx={{
                '& .MuiPaginationItem-root': {
                  fontSize: { xs: '0.75rem', sm: '0.875rem' }
                }
              }}
            />
          </Box>
        </Box>
      )}
      <ParticipantUpdate
        open={modalOpen}
        handleClose={handleCloseModal}
        onSubmit={handleUpdateParticipant}
        participant={currentParticipant}
        gendersList={gendersList}
        specialProtectionGroupsList={specialProtectionGroupsList}
      />
    </>
  );
}

ParticipantList.propTypes = {
  handleParticipantCreate: PropTypes.func.isRequired,
  handleParticipantList: PropTypes.arrayOf(PropTypes.object),
  handleopenNewUpload: PropTypes.func.isRequired,
};
